<template lang="pug">
tr
  td.py-2.text-left
    div.p2 ******{{ card.last4 }}
      template(v-if="$vuetify.breakpoint.mdAndUp")
        v-chip.ml-2(v-if="card.primary" color="primary" small outlined) {{ $t('primary') }}
        //- v-btn.text-capitalize.caption.px-2.ml-2(v-else text color="accent" @click="makePrimary") Make primary
  td.py-2.text-left
    div.p2 {{ card.exp_month }}/{{ card.exp_year }}
  td.py-2
    v-layout
      v-btn.mx-auto(icon @click="startDelete")
        eva-icon(name ="trash-outline" :fill="$vuetify.theme.themes[$theme].danger500")
      //- v-btn(icon @click="")
        v-icon mdi-square-edit-outline
</template>

<script>
export default {
  name: "CardItem",
  props: ['index', 'card'],
  data: () => ({
  }),
  methods: {
    startDelete () {
      this.$emit('confirmDelete', this.card)
    },
    makePrimary () {
      this.$axios.patch(`/billing/cards/${this.card.id}/`, { primary: true })
        .then(() => {
          this.$emit('makePrimary', this.card)
          // location.reload()  // temp solution for updating card list
        })
        .catch(() => {})
    }
  }
}
</script>

<style scoped>
</style>